module.exports = __webpack_public_path__ + "static/img/5.4d1fca6f.png";